import { PayloadAction } from '@reduxjs/toolkit';
import type { LineItemAttachment } from '@snap-types/models/auto-configurator/state';

import { getLineItem } from '../../logic/line-item';
import { WritableAutoConfiguratorState } from '../slice';

type Payload = {
  lineItemUuid: string;
  attachment: LineItemAttachment;
};

export function addLineItemAttachment(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<Payload>,
) {
  const { lineItemUuid, attachment } = action.payload;

  const lineItem = getLineItem(state, lineItemUuid);

  lineItem.attachments.push(attachment);
}
